<template>
  <div class="recharge-box">
    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, i) in state.list"
        :key="i + '-list'"
        :border="false"
      >
        <template #value>
          <div class="item">
            <div class="record-info">
              <div class="div-mid">
                <h3>{{ item.name }}充值</h3>
                <p>{{ item.name_sub }}</p>
              </div>
              <span>{{ item.time }}</span>
            </div>
            <div class="r">+{{ item.amount }}</div>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { reactive, onMounted } from "vue";
// import { useRouter } from 'vue-router'
import { ptbRecord } from "@/api/user";
import { useStore } from "vuex";
import { on } from "events";
import { getQueryString } from "@/utils/location";
export default {
  name: "cashincome",
  setup() {
    const store = useStore();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
    });
    // 加载数据
    var pagecode = 1;
    var totalpage = 1;
    const onLoad = () => {
      // console.log(47444)
      ptbRecord({
        // uid: localStorage.getItem('uid'),
        uid: getQueryString("uid"),
        // c: store.state.username,
        pagecode: pagecode,
      }).then((response) => {
        // console.log("充值数据---------------", response)
        // console.log('当前页数--------------》---------------总页数', pagecode, '------------------', response.data.data.total_page)
        if (response.data.code == 1) {
          totalpage = response.data.data.total_page;
          if (pagecode > response.data.data.total_page) {
            state.finished = true;
            return;
          }
          for (let i = 0; i < response.data.data.lists.length; i++) {
            // console.log(response.data.data.lists[i])
            let list = {
              id: response.data.data.lists[i].id,
              name: response.data.data.lists[i].other,
              time: response.data.data.lists[i].time,
              status: response.data.data.lists[i].state,
              amount: response.data.data.lists[i].money,
              name_sub: response.data.data.lists[i].name_sub,
            };
            state.list.push(list);
            // console.log(state.list)
            state.list = state.list.reverse();
          }
          console.log(pagecode);
          pagecode++;
          state.loading = false;
        }
      });

      // state.loading = false;
      // onMounted(() => {
      //   console.log(4444)
      //   onLoad()
      // })

      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      // 加载状态结束

      // state.loading = false;
      // 数据全部加载完成
      // if (pagecode > totalpage) {
      //   state.finished = true;
      // }
      // pagecode++;
    };
    return {
      state,
      onLoad,
      ptbRecord,
    };
  },
};
</script>

<style scoped="scoped">
.recharge-box {
  /* padding: 32px; */
  /* height: 100% */
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 100px;
}

.recharge-box .item {
  padding: 24px;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  color: #333;
}

.recharge-box .item .l h3 {
  font-size: 28px;
  color: #333;
  margin-bottom: 12px;
}

.recharge-box .item .l p {
  color: #707070;
  font-size: 20px;
}

.recharge-box .item .r {
  font-size: 32px;
  color: #333;
  font-weight: 600;
}
.van-cell {
  background-color: #f7f8fa;
  padding: 0 32px;
}
</style>
